module.exports = __webpack_public_path__ + "static/media/RHSlidingIn.aefb1984.svg";